const faqs = [
  {
    q: '6080新视觉影视需要注册会员才能观看吗？',
    a: '完全不需要！6080新视觉影视坚持免费开放的原则，所有电视剧资源均可直接在线观看，无需注册账号、无需充值会员，打开网站即可享受高清追剧体验。我们相信好内容应该被每个人自由享受。',
  },
  {
    q: '视频画质怎么样？播放流畅吗？',
    a: '平台全站视频采用1080P超高清画质，支持H.265高效编码技术。同时配备智能码率自适应功能，可根据您的网络环境自动调节清晰度，WiFi下享受最高画质，移动数据下也能保持流畅播放不卡顿。',
  },
  {
    q: '剧集更新速度快吗？能同步追新剧吗？',
    a: '我们的更新速度处于行业领先水平，热门电视剧基本与电视台播出同步更新。新剧上线后第一时间收录高清片源，每日定时更新最新剧集。无论是热播新剧还是经典老剧，在这里都能找到。',
  },
  {
    q: '手机和平板可以观看吗？支持哪些设备？',
    a: '6080新视觉影视全面适配PC端、平板和手机端。无论您使用Windows、Mac、Android还是iOS设备，都能获得流畅的观看体验。智能续播功能可以记录您的观看进度，切换设备也能无缝衔接。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-4">
            <i className="ri-question-answer-line text-secondary-400 text-xs"></i>
            <span className="text-secondary-300 text-xs font-medium">常见问答</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            您可能想知道
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            关于6080新视觉影视的常见问题与解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-100 border border-background-200/60 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <div className="w-7 h-7 md:w-8 md:h-8 rounded-lg bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-question-line text-primary-600 text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900">
                      {faq.q}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}